<template>
  <div @click="goHome" class="conent">
      <div :class="tranState ? 'conenttop' : ''"></div>
  </div>
</template>

<script>
export default {
    data () {
        return {
            tranState: false,  // 动画
        }
    },
    created () {
        setTimeout(() => {
            this.tranState = true;
        },500)
    },
    methods: {
        goHome() {  // 返回首页
            this.$router.push({ path: '/hvac/customerscoring/analysis/score' })
        }
    }
}
</script>

<style lang="scss" scoped>
.conent {
    width: 156px;
    height: 156px;
    position: fixed;
    z-index: 9999;
    bottom: 84px;
    right: 20px;
}
.conenttop {
    width: 156px;
    height: 156px;
    background: url("~@/assets/images/user/house/home_icon2.png") no-repeat center/100% 100%;
    animation: sport 0.8s;
    transform: translateY(0px);
}

@keyframes sport {
    0% {
        transform: translateX(156px);
    }
    100% {
        transform: translateX(0px);
    }
}
</style>